"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _taxVatinPageTypes = require("../pages/TaxVatDetailsPage/taxVatinPageTypes");
var _taxNumberActions = require("../actions/taxNumbers/taxNumberActions");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var initialState = {
  taxNumbers: {
    taxin: '',
    vatin: 'DE'
  },
  taxNumbersChangeEvent: {
    taxin: _taxVatinPageTypes.TaxNumberChangeEvents.NONE,
    vatin: _taxVatinPageTypes.TaxNumberChangeEvents.NONE
  },
  isLoading: true,
  hasApiError: false,
  apiErrorMessage: ''
};
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _taxNumberActions.TaxNumbersActions.IS_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: action.isLoading
      });
    case _taxNumberActions.TaxNumbersActions.LOAD_TAX_VAT_NUMBERS:
    case _taxNumberActions.TaxNumbersActions.SAVE_TAX_DATA:
      return _objectSpread(_objectSpread({}, state), {}, {
        taxNumbers: action.taxNumbers,
        isLoading: false
      });
    case _taxNumberActions.TaxNumbersActions.SET_API_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: false,
        hasApiError: true,
        apiErrorMessage: action.apiErrorMessage
      });
    case _taxNumberActions.TaxNumbersActions.SET_TAX_VAT_NUMBERS_CHANGE_EVENTS:
      return _objectSpread(_objectSpread({}, state), {}, {
        taxNumbersChangeEvent: action.taxNumbersChangeEvent
      });
    default:
      return state;
  }
}